<script lang="ts" setup></script>

<template>
  <section class="page-error-404">
    <div class="error-main-content">
      <div class="image-container">
        <img src="~/assets/images/404.svg" alt="Error 404" />
      </div>
      <ErrorsInfo
        title="¡Ups! Algo salió mal."
        description="Disculpa las molestias, ya estamos trabajando para solucionarlo."
      >
        <div class="action-container">
          <UiButton type="is-primary" @click="() => navigateTo({ path: '/' })">
            Volver al inicio
          </UiButton>
        </div>
      </ErrorsInfo>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.page-error-404 {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  min-width: 100vw;
  padding: 40px 32px;
  @media screen and (min-width: $breakpoint-desktop) {
    padding: 33px 33px;
  }
}
.error-main-content {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.image-container {
  width: min(400px, 100%);
}
</style>
